module.exports = __webpack_public_path__ + "img/realworks.b1ba06ef.png";